import React from 'react';
import { Gift, Bike, ShieldCheck } from 'lucide-react';

// Layaway, assembly and warranty cards shown under the Christmas catalog and on each Christmas bike page
const PILLARS = [
    { icon: Gift, title: 'Plan de Apartado Navideño', text: 'Aparta con anticipación y retira en nuestra tienda de Los Prados antes de Nochebuena o Día de Reyes.' },
    { icon: Bike, title: 'Armadas y Calibradas', text: 'Nuestros técnicos del taller oficial revisan frenos, cadena y dirección para que los niños salgan rodando seguros.' },
    { icon: ShieldCheck, title: 'Garantía Local en Tienda', text: 'Local propio en C/ Eliseo Grullón #26, Los Prados, Santo Domingo. Soporte técnico y repuestos disponibles.' }
];

const ChristmasPillars = ({ className = 'mt-20 border-t border-gray-100 pt-12' }) => (
    <div className={`grid grid-cols-1 md:grid-cols-3 gap-6 ${className}`}>
        {PILLARS.map(({ icon: Icon, title, text }) => (
            <div key={title} className="flex items-start gap-4 p-6 bg-zinc-50 rounded-2xl border border-zinc-200/80">
                <div className="w-10 h-10 rounded-xl bg-black text-white flex items-center justify-center shrink-0">
                    <Icon size={20} />
                </div>
                <div>
                    <h4 className="text-sm font-black uppercase tracking-tight text-black mb-1">{title}</h4>
                    <p className="text-xs text-gray-500 leading-relaxed">{text}</p>
                </div>
            </div>
        ))}
    </div>
);

export default ChristmasPillars;
